import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past ~90vh (hero section)
      setVisible(window.scrollY > window.innerHeight * 0.85);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-163">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="fixed bottom-0 left-0 right-0 z-50 md:hidden" data-id="element-164">
          <div className="bg-charcoal/95 backdrop-blur-md border-t border-gold/20 px-4 py-3 safe-area-bottom" data-id="element-165">
            <a href="https://tutiendadigi.shop/cart/51868811428120:1" target="_blank" rel="noopener noreferrer" className="block w-full py-4 btn-metallic-gold text-charcoal font-sans font-black text-base tracking-widest rounded-md shadow-lg shadow-gold/30 active:scale-[0.98] transition-transform text-center" data-id="element-166">
              QUIERO MI CÓDIGO
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}